import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=129bb4ae&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=js"
export * from "./Developer.vue?vue&type=script&lang=js"
import style0 from "./Developer.vue?vue&type=style&index=0&id=129bb4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129bb4ae",
  null
  
)

export default component.exports